<template>
  <div>
    <v-form
      class=frm
      ref='conditionsForm'>
      <div
        v-for='(question, i) in femaleQuestions'
        v-bind:key='i'>
        <v-text-field
          v-if='question.type === "str"'
          v-model="user.health.femaleOnly[i].answer"
          :label="question.question"></v-text-field>

        <v-text-field
          v-else-if='question.type === "int"'
          v-model="user.health.femaleOnly[i].answer"
          :label="question.question"></v-text-field>

        <v-radio-group
          @change='updateLogic(i)'
          v-else-if='question.type === "yn"'
          v-model="user.health.femaleOnly[i].answer">
          {{question.question}}
          <v-radio
            label="yes"
            value="yes"></v-radio>
          <v-radio
            label="no"
            value="no"></v-radio>
        </v-radio-group>
      </div>

       <v-text-field
          v-if='hormoneFollowupQuestion'
          v-model="user.health.femaleOnly[followupQ].followupAnswer"
          label="What kind of hormone replacement, and for how long did you take it?"></v-text-field>

       <v-text-field
          v-if='mammogramFollowupQuestion'
          v-model="user.health.femaleOnly[followupQ].followupAnswer"
          label="How old were you the first time you got a mammogram?"></v-text-field>

         <v-text-field
          v-if='mammogramFollowupQuestion'
          v-model="user.health.femaleOnly[followupQ].followupAnswer2"
          label="How often do you get mammograms?"></v-text-field>

          <v-text-field
          v-if='mammogramFollowupQuestion'
          v-model="user.health.femaleOnly[followupQ].followupAnswer3"
          label="When was your most recent mammogram?"></v-text-field>

            <v-text-field
          v-if='mammogramFollowupQuestion'
          v-model="user.health.femaleOnly[followupQ].followupAnswer4"
          label="Have you ever had a breast biopsy? If yes, How many breast biopsies have you had? and Have you ever had an abnormal breast biopsy result"></v-text-field>

      <v-textarea
        solo
        v-model="user.health.femaleOnly[user.health.femaleOnly.length - 1].answer"
        name="notes"
        label="Please add any other notes or comments here."></v-textarea>
    </v-form>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";

export default {

  props: {
  },
  data: () => ({
    hormoneFollowupQuestion : false,
    mammogramFollowupQuestion : false,
    followupQ : null,
    intRules: [
      v => (v >= 0) || 'Age must be larger than 0',
      v => (/^[0-9]|[1-9][0-9]$/.test(v)) || 'Age must be a number'
    ],
    answers: []
  }),
  methods: {
    updateLogic(i){
      console.log(this.user.health.femaleOnly[i].question)
       if(this.user.health.femaleOnly[i].question === "How often do you get mammograms?" && this.user.health.femaleOnly[i].answer === 'yes'){
         this.mammogramFollowupQuestion = true
         this.followupQ = i
         this.user.health.femaleOnly[this.followupQ].followUpQuestion = 'How old were you the first time you got a mammogram?';
         this.user.health.femaleOnly[this.followupQ].followUpQuestion2 = 'How often do you get mammograms?';
         this.user.health.femaleOnly[this.followupQ].followUpQuestion4 = 'Have you ever had a breast biopsy? If yes, How many breast biopsies have you had? and Have you ever had an abnormal breast biopsy result?';
       }
      else if(this.user.health.femaleOnly[i].question === "Have you ever taken hormone replacement therapy?" && this.user.health.femaleOnly[i].answer === 'yes'){

        this.hormoneFollowupQuestion = true;
        this.followupQ = i
                this.user.health.femaleOnly[this.followupQ].followUpQuestion = 'What kind of hormone replacement, and for how long did you take it?';
      }else{
        this.hormoneFollowupQuestion = false;
        this.mammogramFollowupQuestion = false;
      }
    }
  },
  mounted() {
    if (this.user.health.femaleOnly.length == 0) {
      this.femaleQuestions.forEach((q, i) => {
        this.answers.push({
          question: q.question,
          answer: ''
        })
      })
      this.answers.push({
        question: 'notes',
        answer: ''
      })
      this.user.health.femaleOnly = this.answers
      this.answers = []
    }
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "conditions",
      "femaleQuestions",
      "conditionList"
    ]),
    ...mapFields([
      "user"
    ])
  }
};
</script>
<style>
.frm {
  padding: 20px;
  margin: 5px;
}
</style>
